import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { TextField, Button, StandaloneIcon, TruncateToolTip } from 'Components';
import { string } from 'yup';
import './EmailField.css';

const EmailField = ({
  setPageState,
  emailString,
  pageKey,
  hasTitle,
  delimiter,
  deviceIndex,
  required,
  disabled,
}) => {
  const alsoSendReportToEmail = emailString.split(delimiter).filter(Boolean);

  const [email, setEmail] = useState('');
  const [hasEmailError, setHasEmailError] = useState(false);

  const isMoreThanLimit = String(emailString + email).length >= 2000;

  const removeItem = (i) => {
    setPageState({
      [pageKey]: [
        ...alsoSendReportToEmail.slice(0, i),
        ...alsoSendReportToEmail.slice(i + 1),
      ].join(delimiter),
    });
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
    setHasEmailError(false);
  };

  const handleEmailEnter = (e) => {
    if (e.key !== 'Enter' && e.key !== undefined) return;
    if (isMoreThanLimit) return;
    e.preventDefault();
    const validEmail = string().email(i18n.t('formsDetails:InvalidEmail'));
    if (!validEmail.isValidSync(email)
      || alsoSendReportToEmail.includes(email) || email.length > 100) {
      setHasEmailError(true);
      return;
    }

    setPageState({
      [pageKey]: [
        ...alsoSendReportToEmail,
        email,
      ].join(delimiter),
    });
    setEmail('');
  };

  const enableRequired = !disabled;


  return (
    <div className="email-field">
      {deviceIndex === 1 && hasTitle && <h3>{i18n.t('formsDetails:ALSO SEND REPORT TO')}</h3>}
      <div className="email-field__container">
        <div className="email-field__container__body">
          <TextField
            title={i18n.t('formsDetails:EmailRecipientList')}
            value={email}
            hasError={hasEmailError}
            onChange={handleChange}
            onKeyPress={handleEmailEnter}
            asterisk={required}
            maxLength="100"
          />
          {!isMoreThanLimit && <StandaloneIcon
            onClick={(e) => {
              e.preventDefault();
              handleEmailEnter(e);
            }}
            icon="add_circle"
          />}
        </div>
        {enableRequired && (
        <input
          tabIndex={-1}
          autoComplete="off"
          className="email-field__required"
          value={emailString}
          required={required}
        />
        )}
      </div>
      { alsoSendReportToEmail.map((item, i) => (
        <div key={item} className="email-field__item">
          <TruncateToolTip text={item} />
          <Button onClick={() => removeItem(i)} >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ))}
    </div>
  );
};

EmailField.propTypes = {
  emailString: PropTypes.string,
  pageKey: PropTypes.string,
  setPageState: PropTypes.func,
  deviceIndex: PropTypes.number,
  delimiter: PropTypes.string,
  hasTitle: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

EmailField.defaultProps = {
  emailString: '',
  delimiter: ';',
  hasTitle: false,
  required: false,
  disabled: false,
};

export default EmailField;



// WEBPACK FOOTER //
// ./src/components/EmailField/EmailField.jsx